export const tokenKey = 'Authorization'

// 随机生成字符串
function randomString (e) {
  e = e || 32
  const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const a = t.length
  let n = ''
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
  return n
}

export default {
  getToken () {
    return localStorage.getItem(tokenKey)
  },

  setToken (token) {
    localStorage.setItem(tokenKey, `${randomString(7)}${token}`)
  },

  removeToken () {
    localStorage.removeItem(tokenKey)
  }
}
